import { render, staticRenderFns } from "./maintainOrders-Uploaderimage.vue?vue&type=template&id=235f11ee&scoped=true&"
import script from "./maintainOrders-Uploaderimage.vue?vue&type=script&lang=js&"
export * from "./maintainOrders-Uploaderimage.vue?vue&type=script&lang=js&"
import style0 from "./maintainOrders-Uploaderimage.vue?vue&type=style&index=0&id=235f11ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f11ee",
  null
  
)

export default component.exports